import React, { useState, useEffect } from 'react';
import { Button, Box, Typography, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper } from '@mui/material';
import Sidebar from '../../components/sidebar';
import Header from '../../components/header';
import { useNavigate } from 'react-router-dom';
import feedbackService from '../../services/feedback_service';

const ManagementFeedbackPage = () => {
  const navigate = useNavigate();
  const [feedbacks, setFeedbacks] = useState([]);

  const fetchFeedbacks = async () => {
    try {
      const feedbacksResponse = await feedbackService.getAllFeedbacks();
      console.log("managementFeedback.jsx - fetched feedbacks:", feedbacksResponse);

      if (feedbacksResponse.data) {
        setFeedbacks(feedbacksResponse.data);
      } 
    } catch (error) {
      console.error(error);
    }
  };

  const getReplyStatusText = (reply) => {
    return reply === null ? 'Unfinished' : 'Finished';
  };

  const getTypeText = (type) => {
    switch(type){
      case 1: return 'Feedback';
      case 2: return 'Request';
      case 3: return 'Bug';
      case 4: return 'Complaint';
      case 5: return 'Other';
      default: return '';
    }
  };

  const deleteFeedback = async (id) => {
    try {
      const response = await feedbackService.deleteOneFeedback(id);
      console.log('managementFeedback.jsx - delete feedback response:', response);
      if (response.status === 200) {
        alert("Feedback deleted successfully");
        // Refresh the list of feedbacks
        fetchFeedbacks();
      } else {
        alert("An error occurred while deleting the feedback");
      }
    } catch (error) {
      console.error(error);
      alert("An error occurred while deleting the feedback");
    }
  };

  useEffect(() => {
    fetchFeedbacks();
  }, []);

  return (
    <>
      <Box sx={{ top: 0, left: 0, width: '100%', zIndex: 2 }}>
        <Header />
      </Box>
      <Typography sx={{ fontFamily: 'Titillium Web',marginLeft: '280px' , mt: 2, fontWeight: 'bold' }} variant="h6" component="h3" color="#1C1C1E" mb={1}>
          Manajemen Feedback
      </Typography>
      <Box sx={{ position: 'absolute', top: 64, left: 0, height: '100%', zIndex: 2 }}>
        <Sidebar activeButton="Manajemen Feedback" />
      </Box>
      <Box sx={{ fontFamily: 'inherit' }}>
        <Box sx={{ marginLeft: '280px', marginRight: '10px' }} display="flex" justifyContent="space-between" mb={2}>
          <TableContainer component={Paper} sx={{ fontFamily: 'Titillium Web', maxHeight: '600px' }}>
            <Table aria-label='Daftar Feedback' stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell style={{fontWeight: 'bold'}}>No</TableCell>
                  <TableCell style={{fontWeight: 'bold'}}>ID Feedback</TableCell>
                  <TableCell style={{fontWeight: 'bold'}}>Email Member</TableCell>
                  <TableCell style={{fontWeight: 'bold'}}>Subject</TableCell>
                  <TableCell style={{fontWeight: 'bold'}}>Type</TableCell>
                  <TableCell style={{fontWeight: 'bold'}}>Date</TableCell>
                  <TableCell style={{fontWeight: 'bold'}}>Status</TableCell>
                  <TableCell style={{fontWeight: 'bold'}}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  feedbacks.map((row, index) => (
                    <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{row.id}</TableCell>
                      <TableCell>{row.email}</TableCell>
                      <TableCell>{row.subject}</TableCell>
                      <TableCell>{getTypeText(row.type)}</TableCell>
                      <TableCell>{new Date(row.created_date).toLocaleDateString()}</TableCell>
                      <TableCell>{getReplyStatusText(row.reply)}</TableCell>
                      <TableCell>
                        <Button variant="contained" color="primary" onClick={() => navigate(`/dashboard/management/feedback/detail/${row.id}`)}>View</Button>
                        {row.reply !== null && (
                          <Button variant="contained" color="error" onClick={() => deleteFeedback(row.id)}>Delete</Button>
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                }
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </>
  );
};

export default ManagementFeedbackPage;
